module.exports = __webpack_public_path__ + "static/media/logo_5.d3ba13c4.svg";